import { isCookieConsentAccepted } from "../../utils/cookieConsent";
import {
    Promotion,
    PromotionWithTracking,
    Tracking,
} from "./async-promotion-response";

export const getTrackingData = (
    promotions: Promotion[],
    position: number
): PromotionWithTracking[] => {
    const last = position === -1;
    let slotPosition = last ? -1 : position + 1; // for last position we count from -1 down, for first we count from 1 up

    return promotions.map((promotion, i) => ({
        ...promotion,
        tracking: {
            id: promotion?.campaign?.title,
            name: promotion?.headline,
            position: `slot${last ? slotPosition - i : slotPosition + i}`,
        },
    }));
};

export const setTrackingEventListeners = (): void => {
    Array.from(
        document.querySelectorAll(".js-ux-async-promotion-tracking")
    ).forEach((element) => {
        try {
            const tracking: Tracking = JSON.parse(
                element.getAttribute("data-tracking")
            );
            const url = element.getAttribute("href");
            element.addEventListener("click", (e: Event) => {
                e.preventDefault();
                isCookieConsentAccepted()
                    .then(() => {
                        (window as any).ITdataLayer =
                            (window as any).ITdataLayer || [];
                        (window as any).ITdataLayer.push({ ecommerce: null });
                        (window as any).ITdataLayer.push({
                            event: "promotionClick",
                            ecommerce: {
                                promoClick: {
                                    promotions: [tracking],
                                },
                            },
                            eventCallback: function () {
                                console.log("promotion click tracked");
                                document.location.href = url;
                            },
                        });
                    })
                    .catch(() => {
                        console.log(
                            "promotion tracking failed because cookie was not accepted"
                        );
                        document.location.href = url;
                    });
            });
        } catch (e) {
            console.log("promotion tracking failed");
        }
    });
};

export const trackPromotionsShown = (promotionsTracking: Tracking[]) => {
    (window as any).ITdataLayer = (window as any).ITdataLayer || [];
    (window as any).ITdataLayer.push({ ecommerce: null });
    (window as any).ITdataLayer.push({
        ecommerce: {
            promoView: {
                promotions: promotionsTracking,
            },
        },
    });
};
